import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { RecognitionAuditScreen } from "../../features/recognition-audits/recognition-audit-screen";

export function createRecognitionAuditsRoute(
  dependencies: AdminDashboardDependencies,
): AdminRouteObject {
  return {
    path: "recognition-audits",
    element: <RecognitionAuditScreen dependencies={dependencies} />,
  };
}
